// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"5981f7e6","455":"e18200eb","946":"ae1c5738"}[chunkId] + ".chunk.js";
};